import { first, groupBy, intersection, isEmpty, map, values } from 'lodash'

import useLoggedInUser from './use-logged-in-user'

const addDisabledFlagToElements = (elements, userPermissions) =>
  map(elements, element => {
    const noPermissions =
      !isEmpty(element.permissions) &&
      isEmpty(intersection(userPermissions, element.permissions))

    return {
      ...element,
      isHidden: element.isHiddenBasedOnPermissions && noPermissions,
      disabled: noPermissions,
    }
  })

const useAddDisabledFlagToElements = elements => {
  const loggedInUser = useLoggedInUser()
  if (!loggedInUser) {
    return []
  }

  const filteredElements = map(
    addDisabledFlagToElements(elements, loggedInUser.permissions),
    element => ({
      ...element,
      children: element.children
        ? addDisabledFlagToElements(element.children, loggedInUser.permissions)
        : undefined,
    }),
  )

  const groupedFilteredElements = groupBy(filteredElements, 'key')
  return map(values(groupedFilteredElements), first)
}

export default useAddDisabledFlagToElements
